import React from "react";
import { Box, Typography, Link } from "@material-ui/core";
import useDealerSwr from "hooks/useDealerSwr";

export default function MercadoLibreHelper({ platform, onOpenConfig }) {
    const { dealer } = useDealerSwr();

    if (platform !== "MercadoLibre") return null;

    const mlConfigured = !!dealer?.mlConnected;
    const appId = dealer?.mlAppId;
    // Redirect URI should be the current page or a fixed callback URL.
    // Spec says: https://admin3.nv2smartdealer.com/admin/markerplace-exporter
    const redirectUri = window.location.origin + window.location.pathname;

    return (
        <>
            <Box mt={1}>
                <Typography variant="caption" color="textSecondary" style={{ display: 'block', lineHeight: '1.4' }}>
                    {mlConfigured ? (
                        <span>
                            Integration active.{" "}
                            <Link
                                component="button"
                                variant="caption"
                                onClick={onOpenConfig}
                                style={{ verticalAlign: 'baseline' }}
                            >
                                Edit Configuration
                            </Link>
                        </span>
                    ) : (
                        <span>
                            {appId ? (
                                <span>
                                    Ready to connect.{" "}
                                    <Link
                                        href={`https://auth.mercadolibre.com.pe/authorization?response_type=code&client_id=${appId}&redirect_uri=${encodeURIComponent(redirectUri)}`}
                                        variant="caption"
                                        color="primary"
                                        style={{ verticalAlign: 'baseline' }}
                                    >
                                        Connect now
                                    </Link>
                                    {" or "}
                                    <Link
                                        component="button"
                                        variant="caption"
                                        onClick={onOpenConfig}
                                        style={{ verticalAlign: 'baseline' }}
                                    >
                                        Edit Configuration
                                    </Link>
                                </span>
                            ) : (
                                <span>
                                    MercadoLibre is not configured.{" "}
                                    <Link
                                        component="button"
                                        variant="caption"
                                        onClick={onOpenConfig}
                                        style={{ verticalAlign: 'baseline' }}
                                    >
                                        Click here to configure
                                    </Link>
                                </span>
                            )}
                        </span>
                    )}
                </Typography>
            </Box>
        </>
    );
}
